import React from "react";
import "./Vitri.css";
import Footer from "../Wifi/Footer";

const branches = [
  {
    id: 1,
    city: "Hà Nội",
    address: "Số 180 đường Vạn Phúc, Phường Hà Đông, Thành phố Hà Nội",
  },
  {
    id: 2,
    city: "Hà Nội",
    address: "Số 80 đường Tân Xuân, Phường Đông Ngạc, Thành phố Hà Nội",
  },
  {
    id: 3,
    city: "Hà Nội",
    address: "80 Nguyễn Văn Linh, Long Biên,Thành phố Hà Nội",
  },
  {
    id: 4,
    city: "TP. Hồ Chí Minh",
    address: "Số 180 Võ Văn Ngân, Phường Bình Thọ, Thành phố Thủ Đức",
  },
  {
    id: 5,
    city: "TP. Hồ Chí Minh",
    address: "Số 100 Hòa Bình, Phường Phú Trung, Quận Tân Phú, TP.Hồ Chí Minh",
  },
  {
    id: 6,
    city: "TP. Hồ Chí Minh",
    address:
      "Số 5 Lê Minh Nhựt, Ấp Tiền, Xã Tân Thông Hội, Huyện Củ Chi, TP.HCM.",
  },
];

function LocationIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="bss2-location-svg"
      aria-hidden="true"
    >
      <path
        d="M12 21C12 21 18 15.75 18 10.5C18 7.18629 15.3137 4.5 12 4.5C8.68629 4.5 6 7.18629 6 10.5C6 15.75 12 21 12 21Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle
        cx="12"
        cy="10.5"
        r="2.3"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  );
}

export default function Clonevitri() {
  return (
    <section className="bss2-section">
      <div className="bss2-container">
        <div className="bss2-header">
          <span className="bss2-badge">Hệ thống chi nhánh</span>
          <h2>Hệ thống cửa hàng của chúng tôi</h2>
          <p>
            Hệ thống cơ sở được triển khai tại nhiều khu vực nhằm hỗ trợ khách
            hàng nhanh chóng và thuận tiện hơn.
          </p>
        </div>

        <div className="bss2-grid">
          {branches.map((branch) => (
            <article className="bss2-card" key={branch.id}>
              <div className="bss2-icon-wrap">
                <LocationIcon />
              </div>

              <h3>{branch.city}</h3>
              <p>{branch.address}</p>
            </article>
          ))}
        </div>
        <div className="chantrang">
          <div className="lop-1">
            <h2 className="">Thông tin và chính sách</h2>
          </div>
          <div className="lop-2">
            <p>CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ DU LỊCH ÁNH THÁI DƯƠNG</p>
            <p>Mã số thuế: 0309936637</p>
            <p>Hotline: 0763 823 860</p>
            <p>
              Địa chỉ trụ sở chính: 131 Đường Số 7, Phường Hạnh Thông, TP Hồ Chí
              Minh, Việt Nam
            </p>
            <p>Email: daicaxomtro2m8@gmail.com</p>
            <p className="csbm">
              <a href="/privacy">Chính sách bảo mật</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
